class InputDropdown extends HTMLElement {
  #list;

  static get observedAttributes() {
    return ["open", "options", "overlay"];
  }

  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "closed" });
    const container = document.createElement("div");
    this.#list = container;
    shadow.appendChild(container);
    const style = document.createElement("style");
    style.textContent = this.#generateStyle();

    shadow.appendChild(style);
    this.#handleItemSelection.bind(this);
  }

  disconnectedCallback() {}

  attributeChangedCallback() {
    this.#handleOpen();
  }

  get open() {
    return this.hasAttribute("open");
  }

  get options() {
    return JSON.parse(`[${this.getAttribute("options")}]`)?.sort((a, b) =>
      a < b ? -1 : 1
    );
  }

  get overlay() {
    return this.hasAttribute("overlay");
  }

  get hint() {
    return this.hasAttribute("hint");
  }

  get postfix() {
    return this.getAttribute("postfix");
  }

  #handleOpen() {
    if (this.open) {
      this.#list.innerHTML = `<ul>${this.options
        .map((option) => `<li tabindex = "1">${option}${this.postfix}</li>`)
        .join("")}</ul>`;
      this.#list.querySelectorAll("li").forEach((li) => {
        li.addEventListener("click", this.#handleItemSelection.bind(this));
        li.addEventListener("keydown", this.#handleItemKeydown.bind(this));
      });
      // this.#list.querySelector("li").focus();
    } else {
      this.#list.querySelectorAll("li").forEach((li) => {
        li.removeEventListener("click", this.#handleItemSelection);
        li.removeEventListener("keydown", this.#handleItemKeydown);
      });
      this.#list.innerHTML = "";
    }
  }

  #handleItemSelection({ currentTarget: { innerText } }) {
    this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: true,
        detail: {
          value: innerText
        }
      })
    );
  }

  #handleItemKeydown(e) {
    if (e.keyCode === 13) {
      this.#handleItemSelection(e);
    }
  }
  #generateStyle() {
    return `
    * {
        box-sizing: border-box;
    }
    :host > div {
      position: absolute;
      top: calc(100% - 2px);
      left: 0;
      right: 0;
      z-index: 20;
      max-height: 0;
      transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
      overflow: hidden;
      background: #ffffff;
    }
    :host([hint]) > div {
      top: calc(1.25 * 1.5rem + 2.05rem + 1.3rem + 0.5rem);
    }
    :host([open]) > div {
      transition: max-height 1s ease-in-out;
      max-height: 100vh;
      box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    }
    :host([overlay]) > div {
      top: 1em;
    }
    ul {
      background-color: var(--color-body);
      list-style: none;
      margin: 0;
      padding: 0;
      width: 100%;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
      max-height: 16em;
      overflow-y: auto;
    }
    :host([overlay]) ul {
      border-top-width: 1px;
      border-radius: 3px;
    }
    li {
      font-size: 1.3rem;
      padding: 0.5em 1em;
      cursor: pointer;
    }
    li:hover,li:focus {
      background-color: #22292f;
      color: #fff;
    }
    `;
  }
}

customElements.define("input-dropdown", InputDropdown);
